import {Deserializable} from "./deserializable.model";

export class SystemLogType {

   public log_type_id: number;

   public log_type_name?: string;
   public log_type_description?: string;
   public severity?: string;
   public danger_scale?: number;
   public system_automation_id?: number;
   public system_automation_array?: any;
   public log_insert_name?: string;
   public log_insert_template?: string;
   public log_type_colour?: string;
   public log_type_icon?: string;
   public log_type_data_sector_id?: number;
   public log_level_id?: number;

   public created_tested?: number;
   public notes?: string;
   public is_active?: number;

   log_type_data_sector_colour;

  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SystemLogType {
    Object.assign(this, input);

    return this;
  }


}
